<template>
	<div class="cbs-dropdown-control">
		<legend class="uppercase-first-letter text-solid-gray-1">{{ localValue.title }}</legend>
		<v-select
			multiple
			label="content"
			v-model="localValue.value"
			class="select-multiple w-full"
			:options="localOptionsAttributeValue"
			:placeholder="`${$t('Actions.Choose')} ${localValue.title.toLowerCase()}`"
		>
			<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
		</v-select>
	</div>
</template>

<script>
import vSelect from "vue-select";

export default {
	name: "OptionsControlFilter",
	components: {
		vSelect
	},
	props: {
		value: {
			type: Object,
			required: true,
			validator: prop =>
				prop.hasOwnProperty("id") &&
				prop.hasOwnProperty("value") &&
				prop.hasOwnProperty("title") &&
				prop.hasOwnProperty("control") &&
				prop.hasOwnProperty("attributes")
		}
	},
	computed: {
		localValue: {
			get() {
				return this.value;
			},
			set(val) {
				this.$emit("input", val);
			}
		},
		localAttributesValue() {
			const attributesValue = typeof this.localValue.attributes === "string" ? JSON.parse(this.localValue.attributes) : this.localValue.attributes;
			return attributesValue;
		},
		localOptionsAttributeValue() {
			return this.localAttributesValue.options || [];
		}
	}
};
</script>

<style></style>
